export enum FiltersEvent {
    APPLY = 'filters:apply',
}

export interface FiltersEventMap {
    [FiltersEvent.APPLY]: void;
}
